import { thunkActionLoading } from '@configs'
import { createSlice } from '@reduxjs/toolkit'
import { IApplicant } from 'src/interfaces/application-management'
import { getApplicationAction } from '../actions/application-management'

interface IApplicationManagement {
  applications: IApplicant[] | undefined
  loadings: Record<string, boolean | undefined>
}

const initialState: IApplicationManagement = {
  applications: undefined,
  loadings: {},
}

const applicationManagement = createSlice({
  name: 'applicationManagement',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // job
    builder.addCase(getApplicationAction.pending, (state) => {
      state.loadings[thunkActionLoading.GET_APPLICATION_MANAGEMENT_LOADING] =
        true
    })
    builder.addCase(getApplicationAction.rejected, (state, action) => {
      state.loadings[thunkActionLoading.GET_APPLICATION_MANAGEMENT_LOADING] =
        false
    })
    builder.addCase(getApplicationAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.GET_APPLICATION_MANAGEMENT_LOADING] =
        false
      state.applications = action.payload.data.items
    })
  },
})

export const careerLandingActions = {
  ...applicationManagement.actions,
}

export default applicationManagement.reducer
